import { render } from "./WorkspaceRedirect.vue?vue&type=template&id=8b97fa92&scoped=true"
import script from "./WorkspaceRedirect.vue?vue&type=script&lang=js"
export * from "./WorkspaceRedirect.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-8b97fa92"

export default script